if (!customElements.get('promo-signup-bar')) {
  class PromoSignupBar extends HTMLElement {
    connectedCallback() {
      this.dismissKey = this.dataset.dismissKey;

      if (this.dismissKey && sessionStorage.getItem(this.dismissKey) === 'true') {
        this.hide();
        return;
      }

      const closeButton = this.querySelector('.promo-signup__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          if (this.dismissKey) sessionStorage.setItem(this.dismissKey, 'true');
          this.hide();
        });
      }
    }

    hide() {
      const wrapper = this.closest('.promo-signup-wrapper');
      if (wrapper) {
        wrapper.remove();
      } else {
        this.remove();
      }
    }
  }

  customElements.define('promo-signup-bar', PromoSignupBar);
}
